import { Control, FieldErrors } from 'react-hook-form';
import { StudentProfileForm } from '../../../constants/types/student-profile-form';
import FormRow from '../../common/input/FormRow';
import {
  birthdayRules,
  ENGLISH_NAME_MESSAGE,
  englishNameRules,
} from '../../../constants/validation';
import { Field, ReadOnlyField } from '../../common/form/Field';
import SectionHeader, {
  SectionActionProps,
  SectionBody,
} from '../../common/form/SectionHeader';

/**
 * 영역 1. 학생 기본 정보.
 * 선생님이 대신 입력하는 화면이라 모두 선택 입력이고, 값이 있을 때만 형식을 검사한다.
 */
const BasicInfoSection = ({
  control,
  errors,
  section,
  uid,
  name,
}: {
  control: Control<StudentProfileForm>;
  errors: FieldErrors<StudentProfileForm>;
  section: SectionActionProps;
  /** 수정할 수 없는 항목이라 폼이 아닌 조회 결과에서 바로 받는다. */
  uid?: string;
  name?: string;
}) => {
  const isEditing = section.isEditing;

  return (
    <section>
      <SectionHeader title="기본 정보" {...section} />

      <SectionBody isOpen={section.isOpen}>
        <div className="mt-5 grid grid-cols-1 gap-4 pb-2 xl:grid-cols-2">
          <ReadOnlyField label="아이디" value={uid} hint="수정 불가" />

          {/* 아이디 옆 빈 영역 */}
          <div className="hidden xl:block" />

          <ReadOnlyField label="이름" value={name} hint="수정 불가" />

          <Field label="영어이름" error={errors.englishName?.message}>
            <FormRow
              control={control}
              name="englishName"
              type="text"
              uppercase
              placeholder={ENGLISH_NAME_MESSAGE}
              disabled={!isEditing}
              autoComplete="off"
              rules={englishNameRules()}
              error={!!errors.englishName}
            />
          </Field>

          <Field label="생년월일" error={errors.birthday?.message}>
            <FormRow
              type="birthday"
              name="birthday"
              control={control}
              rules={birthdayRules()}
              disabled={!isEditing}
              error={!!errors.birthday}
            />
          </Field>

          <Field label="성별" error={errors.gender?.message}>
            <FormRow
              type="gender"
              name="gender"
              control={control}
              disabled={!isEditing}
            />
          </Field>
        </div>
      </SectionBody>
    </section>
  );
};

export default BasicInfoSection;
